import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<path d=\"M4.46663 26.0002H8.66663V15.8233L2.66663 11.3335V24.2042C2.66663 25.198 3.47363 26.0002 4.46663 26.0002Z\" fill=\"#4285F4\"></path><path d=\"M23.3334 26.0002H27.5334C28.5294 26.0002 29.3334 25.195 29.3334 24.2042V11.3335L23.3334 15.8233\" fill=\"#34A853\"></path><path d=\"M23.3334 7.87932V16L29.3334 11.315V8.81632C29.3334 6.4988 26.7924 5.17763 25.0134 6.56752\" fill=\"#FBBC04\"></path><path d=\"M8.66663 15.8788V8L16 13.4545L23.3333 8V15.8788L16 21.3333\" fill=\"#EA4335\"></path><path d=\"M2.66663 8.81632V11.315L8.66663 16V7.87932L6.98663 6.56752C5.20463 5.17763 2.66663 6.4988 2.66663 8.81632Z\" fill=\"#C5221F\"></path>", 5)
  ])))
}
export default { render: render }